import ClosedLockIcon from './component'

export default ClosedLockIcon
